import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";

const DuplicateCheckModal = ({ open, duplicates, onClose, onSelectDuplicate }) => {
  const getTypeLabel = (type) => {
    switch (type) {
      case "journalInternational":
        return "Tạp chí quốc tế";
      case "journalDomestic":
        return "Tạp chí trong nước";
      case "conference":
        return "Hội thảo quốc tế";
      case "conferenceDomestic":
        return "Hội thảo trong nước";
      case "chapter":
        return "Chương sách";
      case "workingPaper":
        return "Đang thực hiện";
      case "other":
        return "Khác";
      default:
        return type;
    }
  };

  const getJournalName = (item) => {
    if (item.journal) return item.journal.title;
    if (item.journalDomestic) return item.journalDomestic.title;
    if (item.conference) return item.conference.title;
    return "N/A";
  };
  //   console.log("Duplicates in modal:", duplicates);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Warning style={{ color: "#ff9800" }} />
          <Typography variant="h6">Phát hiện công trình trùng lặp</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom style={{ marginBottom: 16 }}>
          Hệ thống phát hiện có <strong>{duplicates?.length || 0}</strong> công trình khoa học có thể trùng lặp. Bạn có
          thể chọn một công trình để chỉnh sửa.
        </Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Tiêu đề</strong>
                </TableCell>
                <TableCell>
                  <strong>Tạp chí/Hội thảo</strong>
                </TableCell>
                <TableCell>
                  <strong>ISSN</strong>
                </TableCell>
                <TableCell>
                  <strong>Năm</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Thao tác</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {duplicates && Array.isArray(duplicates) && duplicates.length > 0 ? (
                duplicates.map((item, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{item.scientificResearch?.title || "N/A"}</TableCell>
                    <TableCell>{getJournalName(item)}</TableCell>
                    <TableCell>{item.scientificResearch?.issn || "N/A"}</TableCell>
                    <TableCell>{item.scientificResearch?.dashboardYear || "N/A"}</TableCell>
                    <TableCell align="center">
                      <Button variant="outlined" color="primary" size="small" onClick={() => onSelectDuplicate(item)}>
                        Chỉnh sửa
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Không có dữ liệu
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button onClick={onClose} color="default">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DuplicateCheckModal;

